<div class="litmus-toast-container" *ngIf="messages && messages.length">
  <div class="litmus-toast-card {{message.type}}" [class.show]="message.show" *ngFor="let message of messages">
    <!-- Success Icon -->
    <svg *ngIf="message.type === 'success'" class="success-icon" fill="#000000" width="100px" height="100px" viewBox="0 0 30 30" version="1.1"
      preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path class="clr-i-outline clr-i-outline-path-1"
        d="M13.72,27.69,3.29,17.27a1,1,0,0,1,1.41-1.41l9,9L31.29,7.29a1,1,0,0,1,1.41,1.41Z"></path>
      <rect x="0" y="0" width="36" height="36" fill-opacity="0" />
    </svg>
    <!-- Info Icon -->
    <img *ngIf="message.type === 'info'" class="info-icon" src="assets/images/toast-info-icon.svg">
    <!-- Warning Icon -->
    <img *ngIf="message.type === 'warning'" class="warning-icon" src="assets/images/toast-warning-icon.svg">
    <!-- Error Icon -->
    <svg *ngIf="message.type === 'error'" class="error-icon" width="100px" height="100px" viewBox="0 0 16 16" 
      xmlns="http://www.w3.org/2000/svg" fill="#000000"><path fill-rule="evenodd"
      clip-rule="evenodd" d="M8.6 1c1.6.1 3.1.9 4.2 2 1.3 1.4 2 3.1 2 5.1 0 1.6-.6 3.1-1.6 4.4-1 1.2-2.4 2.1-4 2.4-1.6.3-3.2.1-4.6-.7-1.4-.8-2.5-2-3.1-3.5C.9 9.2.8 7.5 1.3 6c.5-1.6 1.4-2.9 2.8-3.8C5.4 1.3 7 .9 8.6 1zm.5 12.9c1.3-.3 2.5-1 3.4-2.1.8-1.1 1.3-2.4 1.2-3.8 0-1.6-.6-3.2-1.7-4.3-1-1-2.2-1.6-3.6-1.7-1.3-.1-2.7.2-3.8 1-1.1.8-1.9 1.9-2.3 3.3-.4 1.3-.4 2.7.2 4 .6 1.3 1.5 2.3 2.7 3 1.2.7 2.6.9 3.9.6zM7.9 7.5L10.3 5l.7.7-2.4 2.5 2.4 2.5-.7.7-2.4-2.5-2.4 2.5-.7-.7 2.4-2.5-2.4-2.5.7-.7 2.4 2.5z"/>
    </svg>
    <div class="toas-card-body">
      <div class="litmus-toast-header">{{message.header}}</div>
      <div class="litmus-toast-message" [innerHtml]="message.message"></div>
    </div>
    <button class="toast-action-btn" (click)="removeMessage(message)">Okay</button>
  </div>
</div>